import { frontendURL } from '../../../helper/URLHelper';
import InicioIndex from './pages/InicioIndex.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/inicio'),
    alias: [
      frontendURL('accounts/:accountId'),
      frontendURL('accounts/:accountId/index'),
      frontendURL('accounts/:accountId/home'),
    ],
    name: 'inicio_index',
    component: InicioIndex,
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
  },
];
